import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';

export const getInfracaoMotoristaColumns = (onEdit, onDelete, loadingEditId, loadingDeleteId) => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    size: 80,
    cell: ({ row }) => row.original.id ?? '-'
  },
  {
    id: 'cpfMotorista',
    accessorKey: 'cpfMotorista',
    header: 'CPF Motorista',
    size: 160,
    cell: ({ row }) => row.original.cpfMotorista || '-'
  },
  {
    id: 'mesFechamento',
    accessorKey: 'mesFechamento',
    header: 'Mes',
    size: 80,
    cell: ({ row }) => row.original.mesFechamento ?? '-'
  },
  {
    id: 'anoFechamento',
    accessorKey: 'anoFechamento',
    header: 'Ano',
    size: 80,
    cell: ({ row }) => row.original.anoFechamento ?? '-'
  },
  {
    id: 'descricaoInfracao',
    accessorKey: 'descricaoInfracao',
    header: 'Infracao',
    size: 220,
    cell: ({ row }) => row.original.descricaoInfracao || '-'
  },
  {
    id: 'acoes',
    header: 'Acoes',
    size: 120,
    cell: ({ row }) => (
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip dir="top" text="Editar">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-primary"
              size="sm"
              loading={loadingEditId === row.original.id}
              disabled={loadingEditId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(row.original.id);
              }}
            >
              <Icon name="pencil" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
        <Tooltip dir="top" text="Excluir">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-danger"
              size="sm"
              loading={loadingDeleteId === row.original.id}
              disabled={loadingDeleteId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onDelete(row.original.id);
              }}
            >
              <Icon name="trash" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
      </div>
    ),
    enableSorting: false
  }
];
